// extracted by mini-css-extract-plugin
export const button = "IconButton-module--button--1eY7r";
export const pressed = "IconButton-module--pressed--1kWts";
export const tooltip = "IconButton-module--tooltip--3weQZ";